import { searchCustomers } from '~/api/v2';
import { useSearch } from '~/components/QuickNav/useSearch';

const RESULT_LIMIT = 10;

function search(query: string, signal?: AbortSignal) {
    return searchCustomers({ query: { query, limit: RESULT_LIMIT }, signal });
}

export function useCustomerSearch(query: string, enabled: boolean) {
    const { results, pending, failed } = useSearch(query, enabled, search);
    return { customers: results, pending, failed };
}
